<template>
  <v-footer style="
      margin-top: 64px;
          position: relative;
    z-index: 1;
      " :style="{
        'min-height': minHeight,
      }" class="pa-0">
    <img src="/images/main/forest.jpeg"
    alt="Hintergrundbild Wald"
    style="width: 100vw; height: 100%; position: absolute; object-fit: cover;"
      :style="{
        opacity: backoffice || profile ? 0.4 : 1,
        color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))'
      }" />
    <WaveVue :inverted="false" style="position: absolute; top: 0" v-if="!backoffice && !profile"
      :style="{ 'margin-top': isMobile ? '15px' : '0px' }" :height="isMobile ? 30 : 120" />

    <v-container fluid :class="{ 'mb-4': isMobile, }" style="z-index: 5;"
      :style="{ 'margin-top': isMobile ? '100px !important' : '' }">
      <v-row>
        <v-spacer />
        <v-col :cols="mainCols" v-if="!backoffice && !profile">
          <v-container fluid>
            <v-row>
              <v-col cols="auto"
                :style="{ color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))' }">
                <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                <h2 class="pb-4">{{ $t("landing.contactText") }}</h2>
                <a href="/kontakt#contactFormId">
                  <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                  }}</v-btn>
                </a>
                <br>
                <small><i>{{ $t("landing.contactButtonText") }}</i></small>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-col :cols="mainCols">
          <v-container fluid style="height: 100%; display: flex; flex-direction: column;" class="pb-0">
            <v-row style="flex-grow: 0">
              <v-spacer />
              <v-col cols="auto" class="pb-0">
                <a :style="{
                  color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))'
                }" class="footerLink" href="/impressum">{{
                  $t("basics.imprint")
                }}</a>
              </v-col>
            </v-row>
            <v-row style="flex-grow: 0">
              <v-spacer />
              <v-col cols="auto" class="pt-0">
                <a :style="{
                  color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))'
                }" class="footerLink" href="/datenschutzerklaerung">{{
                  $t("basics.privacy")
                }}</a>
              </v-col>
            </v-row>
            <v-row style="flex-grow: 0">
              <v-spacer />
              <v-col cols="auto" class="pt-0">
                <a :style="{
                  color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))'
                }" class="footerLink" href="/agb">{{
                  $t("basics.agb")
                }}</a>
              </v-col>
            </v-row>

            <div style="flex-grow: 1"></div>

            <v-row style="flex-grow: 0">
              <v-spacer />
              <v-col cols="auto" style="text-align: center;color: rgb(var(--v-theme-light))" class="pb-0">
                v. 1.0.0
              </v-col>
            </v-row>
            <v-row style="flex-grow: 0">
              <v-spacer />
              <v-col cols="auto" style="text-align: center" class="pt-0"
                :style="{ color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))' }">
                &copy;<a href="https://roba.one/" style="text-decoration: none;" :style="{
                  color: backoffice || profile ? 'rgb(var(--v-theme-on-surface))' : 'rgb(var(--v-theme-light))'
                }" target="_blank" large block>roba.one</a>
                2026, Alle
                Rechte vorbehalten.
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-spacer v-if="!backoffice && !profile" />
      </v-row>

      
            <v-row style="flex-grow: 0">
              <v-spacer />

              <v-col cols="12" md="8" style="text-align: center" class="pt-0" :style="{
                color: backoffice || profile
                  ? 'rgb(var(--v-theme-on-surface))'
                  : 'rgb(var(--v-theme-light))'
              }">
                <p>
                  {{ $t("diagnosisNotice.intro") }}
                  <a href="/diagnosen/index.html" target="_blank" rel="noopener noreferrer"
                    style="color: inherit; text-decoration: underline;">
                    {{ $t("diagnosisNotice.link") }}
                  </a>
                </p>
              </v-col>

              <v-spacer />
            </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "footerComponent",

  computed: {
    minHeight() {
      console.log(window.innerHeight)
      if (this.backoffice || this.profile) {
        if (window.innerHeight * 0.18 >= 300)
          return '18vh'

        return "300px"
      }
      else {
        if (window.innerHeight * 0.45 >= 500)
          return '45vh'

        return "500px"
      }

    },
    backoffice() {
      return this.$route.path.startsWith("/backoffice")
    },
    profile() {
      return this.$route.path.startsWith("/main")
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    mainCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 4;
        default:
          return 4;
      }
    },
    WaveHeight() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return "30px";
        case "sm":
          return "30px";
        case "md":
          return "120px";
        case "lg":
          return "120px";
        case "xl":
          return "120px";
        case "xxl":
          return "120px";
        default:
          return "120px";
      }
    },
    WaveMargin() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return "15px";
        case "sm":
          return "15px";
        case "md":
          return "15px";
        case "lg":
          return "15px";
        case "xl":
          return "15px";
        case "xxl":
          return "15px";
        default:
          return "15px";
      }
    },
  },

  methods: {},
};
</script>
